import React, { Component } from "react";
import { questionType } from "../../utils/Constants";

class AssessmenttQuestions extends Component {
  state = {};

  calcualteCorrectObjectiveAns = () => {};

  render() {
    let { practicalQuestions, theoryQuestions } = this.props;
    return (
      <div className="container-fluid">
        <>
          {theoryQuestions && theoryQuestions.length > 0 && (
            <div className="">
              <div className="row">
                <div className="col">
                  <div className="row p-2">
                    <div className="col">
                      <div className="tt-group-header">Theory</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col p-4">
                  {theoryQuestions &&
                    theoryQuestions.map((q, idx) => (
                      <>
                        <div className="row">
                          <div className="col-md-1">
                            <span>
                              <strong>{`${idx + 1})`}&nbsp;</strong>
                            </span>
                          </div>
                          <div className="col-md-7">{q.question}</div>
                          <div className="col-md-2">
                            <label>Marks weight:</label>
                            <input
                              className="ml-1"
                              type="number"
                              name="markWight"
                              value={q?.markWeight}
                              disabled
                            />
                          </div>
                          <div className="col-md-2">
                            <label>Obtained:</label>
                            <input
                              className="ml-1"
                              type="number"
                              name="obtainedMarks"
                              value={q?.obtainedMarks}
                              onChange={(e) =>
                                this.props.handleMarksChange(
                                  e,
                                  "theoryQuestions",
                                  idx
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            {q.questionType === questionType.SUBJECTIVE ? (
                              <>
                                <div className="row mt-2 mb-2" key={idx}>
                                  <div className="col-md-3"></div>
                                  <div className="col-md-7">
                                    <textarea
                                      className="form-control"
                                      rows={4}
                                      name="subjectiveAnswer"
                                      value={q.answer?.subjectiveAnswer}
                                      onChange={(e) =>
                                        this.props.handleMarksChange(
                                          e,
                                          "theoryQuestions",
                                          idx
                                        )
                                      }
                                      disabled
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Remarks</label>
                                    <textarea
                                      className="form-control"
                                      name="remarks"
                                      value={q.remarks}
                                      onChange={(e) =>
                                        this.props.handleMarksChange(
                                          e,
                                          "theoryQuestions",
                                          idx
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            ) : q.questionType === questionType.OBJECTIVE ? (
                              <>
                                {q.subjectQuestionOptions &&
                                  q.subjectQuestionOptions.length > 0 &&
                                  q.subjectQuestionOptions.map((opt, oIdx) => (
                                    <>
                                      <div className="row mt-2 mb-2" key={oIdx}>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-7">
                                          <div className="row">
                                            <div className="col-md-2 text-center">
                                              <input
                                                type="checkbox"
                                                name="ticked"
                                                checked={
                                                  q?.answer
                                                    ?.subjectQuestionOptionId ===
                                                  opt.id
                                                }
                                                style={{
                                                  position: "relative",
                                                  top: "8px",
                                                }}
                                                onClick={(e) =>
                                                  this.props.handleMarksChange(
                                                    e,
                                                    "theoryQuestions",
                                                    idx
                                                  )
                                                }
                                              ></input>
                                            </div>
                                            <div className="col-md-10 text-center">
                                              <input
                                                type="text"
                                                className="form-control"
                                                name="optionValue"
                                                value={opt.optionValue}
                                                style={{
                                                  backgroundColor: opt.isCorrect
                                                    ? "#f0fcf0"
                                                    : "#FFCCCC",
                                                }}
                                              ></input>
                                            </div>
                                          </div>
                                        </div>
                                        {oIdx === 0 && (
                                          <div className="col-md-2">
                                            <label>Remarks</label>
                                            <textarea
                                              className="form-control"
                                              name="remarks"
                                              onChange={(e) =>
                                                this.props.handleMarksChange(
                                                  e,
                                                  "theoryQuestions",
                                                  idx
                                                )
                                              }
                                              value={q.remarks}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  ))}
                              </>
                            ) : null}
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                </div>
              </div>
            </div>
          )}
        </>
        <>
          {practicalQuestions && practicalQuestions.length > 0 && (
            <div className="">
              <div className="row">
                <div className="col">
                  <div className="row p-2">
                    <div className="col">
                      <div className="tt-group-header">Practical</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col p-4">
                  {practicalQuestions &&
                    practicalQuestions.map((q, idx) => (
                      <>
                        <div className="row">
                          <div className="col-md-1">
                            <span>
                              <strong>{`${idx + 1})`}&nbsp;</strong>
                            </span>
                          </div>
                          <div className="col-md-7">{q.question}</div>
                          <div className="col-md-2">
                            <label>Marks weight</label>
                            <input
                              className="ml-1"
                              type="number"
                              name="markWight"
                              value={q?.markWeight}
                              disabled
                            />
                          </div>
                          <div className="col-md-2">
                            <label>Obtained:</label>
                            <input
                              className="ml-1"
                              type="number"
                              name="obtainedMarks"
                              value={q?.obtainedMarks}
                              onChange={(e) =>
                                this.props.handleMarksChange(
                                  e,
                                  "practicalQuestions",
                                  idx
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            {q.questionType === questionType.SUBJECTIVE ? (
                              <>
                                <div className="row mt-2 mb-2" key={idx}>
                                  <div className="col-md-3"></div>
                                  <div className="col-md-7">
                                    <textarea
                                      className="form-control"
                                      rows={4}
                                      name="subjectiveAnswer"
                                      value={q.answer?.subjectiveAnswer}
                                      disabled
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Remarks</label>
                                    <textarea
                                      name="remarks"
                                      className="form-control"
                                      onChange={(e) =>
                                        this.props.handleMarksChange(
                                          e,
                                          "practicalQuestions",
                                          idx
                                        )
                                      }
                                      value={q.remarks}
                                    />
                                  </div>
                                </div>
                              </>
                            ) : q.questionType === questionType.OBJECTIVE ? (
                              <>
                                {q.subjectQuestionOptions &&
                                  q.subjectQuestionOptions.length > 0 &&
                                  q.subjectQuestionOptions.map((opt, oIdx) => (
                                    <>
                                      <div className="row mt-2 mb-2" key={oIdx}>
                                        <div className="col-md-3"></div>
                                        <div className="col-md-7">
                                          <div className="row">
                                            <div className="col-md-2 text-center">
                                              <input
                                                type="checkbox"
                                                name="ticked"
                                                checked={
                                                  q?.answer
                                                    ?.subjectQuestionOptionId ===
                                                  opt.id
                                                }
                                                onClick={(e) =>
                                                  this.props.handleMarksChange(
                                                    e,
                                                    "practicalQuestions",
                                                    idx,
                                                    oIdx
                                                  )
                                                }
                                                style={{
                                                  position: "relative",
                                                  top: "8px",
                                                }}
                                              ></input>
                                            </div>
                                            <div className="col-md-10 text-center">
                                              <input
                                                type="text"
                                                className="form-control"
                                                name="optionValue"
                                                value={opt.optionValue}
                                                style={{
                                                  backgroundColor: opt.isCorrect
                                                    ? "#f0fcf0"
                                                    : "#FFCCCC",
                                                }}
                                              ></input>
                                            </div>
                                          </div>
                                        </div>
                                        {oIdx === 0 && (
                                          <div className="col-md-2">
                                            <label>Remarks</label>
                                            <textarea
                                              name="remarks"
                                              className="form-control"
                                              onChange={(e) =>
                                                this.props.handleMarksChange(
                                                  e,
                                                  "practicalQuestions",
                                                  idx
                                                )
                                              }
                                              value={q.remarks}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  ))}
                              </>
                            ) : null}
                          </div>
                        </div>
                        <hr />
                      </>
                    ))}
                </div>
              </div>
            </div>
          )}
        </>
      </div>
    );
  }
}

export default AssessmenttQuestions;
